<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card tile>
          <v-card-title>{{
            $t("common." + (edition_mode ? "edit" : "add"))
          }}</v-card-title>
          <v-divider />
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                v-model="formModel.first_name"
                :label="$t('user.first_name')"
                required
                :rules="required_rule"
              />
              <v-text-field
                v-model="formModel.last_name"
                :label="$t('user.last_name')"
                required
                :rules="required_rule"
              />
              <v-text-field
                v-model="formModel.email"
                :label="$t('user.email')"
                :rules="emailRules"
                required
              />

              <v-select
                :label="$t('common.role.title')"
                :items="roles"
                v-model="formModel.role"
                item-value="key"
                item-text="value"
              />
              <v-select
                :label="$t('user.archived')"
                :items="archived"
                v-model="formModel.archived"
                item-value="key"
                item-text="value"
              />
              <v-text-field
                v-if="
                  !['ADMIN', 'MENTOR', 'SUPERADMIN'].includes(formModel.role)
                "
                v-model="formModel.year"
                :label="$t('user.year')"
                required
                :rules="required_rule"
              />
              <v-checkbox
                v-if="['MENTOR'].includes(formModel.role)"
                v-model="formModel.is_admin"
                :label="$t('user.is_admin')"
              ></v-checkbox>
              <SquadPicker
                v-if="
                  !['ADMIN', 'MENTOR', 'SUPERADMIN'].includes(formModel.role)
                "
                v-model="formModel.squad"
                :label="$t('user.squad')"
                required
              />
            </v-form>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
          <v-card-actions>
            <v-btn text @click="$router.go(-1)">{{
              $t("common.cancel")
            }}</v-btn>
            <v-spacer />
            <v-btn tile color="primary" @click="_submit" :loading="loading">{{
              $t("common." + (edition_mode ? "edit" : "save"))
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex"
import { ADD, UPDATE, FETCH_ONE } from "@/store/action-types"
import { ROLES } from "@/utils/config"
import FormMixin from "@/mixins/FormMixin"
import SquadPicker from "@/components/form/SquadPicker"

export default {
  name: "userForm",
  components: { SquadPicker },
  mixins: [FormMixin],
  data() {
    return {
      show1: false,
      formModel: {
        role: "PEF",
      },
      valid: true,
    }
  },
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
    roles() {
      return Object.keys(ROLES).map((value) => {
        let disabled = false
        if (
          this.current_user.role === "MENTOR" &&
          value.toLowerCase() === "admin" &&
          !this.current_user.is_admin
        ) {
          disabled = true
        }
        return {
          disabled: disabled,
          key: value,
          value: this.$t("common.role." + value.toLowerCase()),
        }
      })
    },
    archived() {
      return [
        {
          key: true,
          value: this.$t("common.yes"),
        },
        {
          key: false,
          value: this.$t("common.no"),
        },
      ]
    },
  },
  async mounted() {
    if (this.$route.params.user_id) {
      this.edition_mode = true
      let self = this
      this.loading = true
      await this.FETCH_ONE(this.$route.params.user_id)
        .then((data) => {
          self.$set(self, "formModel", data)
        })
        .finally(() => {
          self.loading = false
        })
    }
  },

  methods: {
    ...mapActions("user", [FETCH_ONE, UPDATE, ADD]),
    _submit() {
      this.submit(
        [
          "id",
          "first_name",
          "last_name",
          "email",
          "year",
          "squad",
          "role",
          "password",
          "is_admin",
          "archived",
        ],
        () => "/admin",
        "squad"
      )
    },
  },
}
</script>
